module.exports = __webpack_public_path__ + "static/media/aquarianlogo.719f99f3.png";